import CommonStyles from "../../../../../Diathrive/src/utils/CommonStyles";
import { COLORS } from "../../../../../Diathrive/src/utils/Constants";

const styles = {
  cameraOverlay: {
    background: "rgba(0, 0, 0, 0.2)",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  camera: {
    width: "75%",
    maxHeight: "75%",
  },
  icon: {
    width: 24,
    height: 24,
    borderRadius: 24,
    background: "dimgrey",
    padding: 12,
  },
  actionButtonsContainer: {
    display: "flex",
    width: 224,
    height: 56,
    ...CommonStyles.mt_24,
  },
  cancelButton: {
    borderColor: COLORS.white,
    ...CommonStyles.full_flex,
    ...CommonStyles.mr_24,
  },
  captureButton: {
    backgroundColor: COLORS.red,
    ...CommonStyles.full_flex,
  },
};

export default styles;
